import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/privacy";



const App = () => {
	return (

		<BrowserRouter>
			<Routes>
			<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/terms-and-conditions" element={<TermsAndConditions />} />
				<Route path="/" element={<Home />} />
			</Routes>

		</BrowserRouter>

	);
};

export default App;